export enum eLoaiToKhai {
    DANG_KY_MOI = 1,
    THAY_DOI_THONG_TIN = 2
}